import {Card, Col, Empty, Row, Timeline, Image} from "antd";
import {Fragment, useEffect, useState} from "react";
import {Button, Loading, StatusLabel} from "../../../components";
import {useParams} from "react-router-dom";
import {apiError, handleRequest, renderDate} from "../../../utils";
import {requestDemoApi} from "../../../api";
import DOMPurify from "dompurify";
import {RequestDemoComment} from "../components";
import _ from "lodash";


function RequestDemoDetail()
{
    const {id} = useParams();

    const [loading, setLoading] = useState(true);

    const [errorLoad, setErrorLoad] = useState(false);

    const [requestDemo, setRequestDemo] = useState({});

    let [histories, setHistories] = useState([]);

    const eventsHandler = {
        load: async () => {

            let [error, response] = await handleRequest(requestDemoApi.detail({
                id: id
            }));

            let message = apiError(`Load yêu cầu thất bại`, error, response);

            if (!message)
            {
                setRequestDemo(response.data);
                setErrorLoad(false)
            }
            else
            {
                setErrorLoad(true);
            }

            setLoading(false);
        },
        history: async () => {

            let [error, response] = await handleRequest(requestDemoApi.history(id));

            let message = apiError(`Load lịch sử yêu cầu thất bại`, error, response);

            if (!message)
            {
                setHistories(response.data);
            }
        },
    }

    const Histories = ({histories}) => {
        if(_.isEmpty(histories)) return ''
        return (
            <>
                <p className="heading">Lịch sử hoạt động</p>
                <Timeline>
                    {
                        histories.map((timeLine) => {
                            return (
                                <Fragment key={`timeLine-${timeLine.date}`}>
                                    <Timeline.Item color="red">{timeLine.date}</Timeline.Item>
                                    {
                                        timeLine.list.map((timeMessage) => {
                                            return (
                                                <Timeline.Item key={`timeLine-item-${timeMessage.id}`}>
                                                    <p style={{marginTop : '10px'}} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(`<b>${timeMessage.hour}</b>  ${timeMessage.message}`) }} />
                                                </Timeline.Item>
                                            )
                                        })
                                    }
                                </Fragment>
                            )
                        })
                    }
                </Timeline>
            </>
        )
    }

    useEffect(() => {
        eventsHandler.load().then()
        eventsHandler.history().then()
    }, [id])

    if(loading) {
        return (
            <div className="container">
                <Loading/>
            </div>
        )
    }

    if(errorLoad) {
        return (
            <div className="container">
                <Empty description={<span>Không có yêu cầu duyệt Demo</span>}><Button to={'/request-demo'}>Quay lại danh sách yêu cầu</Button></Empty>
            </div>
        )
    }

    return (
        <div className="container d-block">
            <div className="content pd-2" style={{overflow: 'auto'}}>
                <section className={'mb-3'}>
                    <Row gutter={16}>
                        <Col className="gutter-row" span={6}>
                            <Card title="Thông tin" className={'mb-2'}>
                                <p className='mb-1'><b>Mã yêu cầu:</b> <b>RD{requestDemo.id}</b> - {renderDate(requestDemo.created)}</p>
                                <p className='mb-1'><b>Hợp đồng:</b> {requestDemo.contract.code} {requestDemo.contract.name}</p>
                                <p><b>Trạng thái:</b> <StatusLabel className={'mb-0'} type={requestDemo.status.badge}>{requestDemo.status.label}</StatusLabel></p>
                            </Card>
                            <Card title="Link Demo" className={'mb-2'}>
                                <Button background blue href={requestDemo.url} target={'_blank'}>Mở ảnh demo</Button>
                            </Card>
                            <Card title="Chữ ký" className={'mb-2'}>
                                {!_.isEmpty(requestDemo?.signature) && <Image src={requestDemo.signature} />}
                            </Card>
                        </Col>
                        <Col className="gutter-row" span={8}>
                            <section className={'mb-3'}>
                                <RequestDemoComment requestDemo={requestDemo} />
                            </section>
                        </Col>
                        <Col className="gutter-row" span={8}>
                            <section className={'mb-3'}>
                                <Histories histories={histories} />
                            </section>
                        </Col>
                    </Row>
                </section>
            </div>
        </div>
    )
}

export default RequestDemoDetail;